<template>
  <div class="glass-container">
    <transition v-for="(src, key) in images" :key="key" name="glass">
      <img v-if="key == showKey" :src="src">
    </transition>
  </div>
</template>

<script>
import gaussWorker from './glass.worker.js'
export default {
  name: 'glass',
  props: {
    
  },
  data () {
    return {
      currentKey: '',
      showKey: '',
      worker: null,
      images: {}
    }
  },
  created () {
    this.worker = new gaussWorker()
    this.worker.onmessage = (event) => {
      var { key, imgData} = event.data
      if(this.images.hasOwnProperty(key) && this.images[key]){
        return
      }
      var canvas = document.createElement('canvas')
      canvas.width = imgData.width;
      canvas.height = imgData.height;
      var context = canvas.getContext("2d");
      context.putImageData(imgData,0,0);
      this.$set(this.images, key, canvas.toDataURL("image/png"))
      if(this.currentKey == key){
        this.$nextTick(()=>{
          this.showKey = key
        })
      }
    }
  },
  mounted() {
    this.$on('draw', (src) => {
      this.currentKey = src
      if(!this.images.hasOwnProperty(src)){
        this.drawImg(src)
      }else if(this.images[src]){
        this.showKey = src
      }
    })
  },
  beforeDestroy() {
    this.worker.terminate()
  },
  methods: {
    drawImg(imgsrc) { // 下载图片地址和图片名
      this.$set(this.images, imgsrc, '')
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      // image.crossOrigin = 'anonymous'
      image.onload = () => {
        var canvas = document.createElement('canvas')
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0);
        var canvasData = context.getImageData(0, 0, canvas.width, canvas.height);
        this.worker.postMessage({imgData: canvasData, radius: 200, key: imgsrc})
      }
      image.src = imgsrc
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.glass-leave,
.glass-enter-to{
  opacity: 1;
}
.glass-enter,
.glass-leave-to{
  opacity: 0;
}
.glass-enter-active,
.glass-leave-active{
  transition: opacity 1s ease;
}

.glass-container{
  width: 100%;
  height: 100%;
  position: relative;
  &>img{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
@keyframes show{
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
</style>
